export default "__VITE_PUBLIC_ASSET__0d521faa__"